import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import { Context } from '../shared'
import { featureFlags, FeatureFlag } from '../types/feature-flags'

export const currentFeatureFlags: GraphQLFieldConfig<any, Context> = {
  type: new GraphQLNonNull(featureFlags),
  description: 'Feature flags',
  args: {},
  async resolve(
    _source,
    _args,
    context
  ): Promise<{
    readonly items: FeatureFlag[]
  }> {
    const flags = await context.connector.get(
      '/feature/flags?expand=skip_links'
    )

    return {
      items: flags
        ? flags.map(({ key, active }) => {
            return {
              id: key,
              active
            }
          })
        : []
    }
  }
}
